import styled from 'styled-components';

const Label = styled.label`
  display: block;
  font-size: var(--font-h3);
  font-weight: var(--font-bold);
`;

export default Label;
